module.exports = __webpack_public_path__ + "static/img/naturesway.166e187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/naturesway.jpg
// module id = 247
// module chunks = 1